import 'rxjs/add/operator/map';

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MdPaginator, MdSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { IesHttpClient } from '../../Common/ies-http-client.service';
import { Enum } from '../../utility/enum.enum';
import { AppUrl } from './../../Common/appUrl';
import { TableDataSource } from './../../Common/md-table';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { userRole_regionalAdmin } from './../../Common/appConstant';
import { FeatureFlagService, ToggleName } from 'app/Common/Services/feature-flag.service';


@Component({
  selector: 'app-adm-manage-regional-admin',
  templateUrl: './adm-manage-regional-admin.component.html',
  styleUrls: ['./adm-manage-regional-admin.component.css'],
  providers: [FeatureFlagService],
})
export class AdmManageRegionalAdminComponent implements OnInit, OnDestroy {
  @ViewChild(MdPaginator) paginator: MdPaginator;
  @ViewChild(MdSort) sort: MdSort;

  // used in html to pass url/searchParams to update pagination
  appUrl = AppUrl;
  httpClient: IesHttpClient; // used to make object of md-table
  form: FormGroup;
  regionFilteredOptions: any;
  nameFilteredOptions: any;
  isSearchDisable: boolean;
  dataSource: TableDataSource | null;
  dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // store all grid data
  adminDetailPaginationInfo: any = { totalRecords: 0 }; // Set initial value of Totalrecords property
  displayedColumns = ['firstName', 'lastName', 'email', 'regionName', 'contactNo', 'status', 'Action'];
  constructor(private featureFlags: FeatureFlagService, private _sharedService: SharedService, public _utility: Utility, httpClient: IesHttpClient, public _appGlobal: AppGlobals) {
    this.httpClient = httpClient;
    this.form = new FormGroup(
      {
        searchNameControl: new FormControl(),
        searchRegionControl: new FormControl()
      }
    )

  }

  private redirect(): void {
    window.location.assign("/ies/internal/manage-regional-administrators");
  }

  ngOnInit() {
    this.featureFlags.on("ready", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_MANAGE_REGIONAL_ADMINISTRATORS_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.on("update", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_MANAGE_REGIONAL_ADMINISTRATORS_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.start();
    // to get data of Regional Admin and bind with Grid
    this._utility.addLoaderCount();
    this._sharedService.getUsers("?userRole=" + userRole_regionalAdmin).subscribe((response: any) => {
      this._utility.onSuccessCallback(response, null, () => {
        this.dataSubject.next(response.response.results);
        this.adminDetailPaginationInfo = response.response.paginationInfo; // update paginaton info
      });
    }, error => this._utility.onErrorCallback(error));

    // to get data of all regions and bind with AutoComplete
    if (this._sharedService.regionList) {
      this._utility.setDataInComboField('region', null, this.form.controls.searchRegionControl, this);
    } else {
      this._utility.addLoaderCount();
      this._sharedService.getComboFieldsData(Enum.Region, (response) => {
        this._utility.removeLoaderCount();
        this._sharedService.regionList = response.response;
        this._utility.setDataInComboField('region', null, this.form.controls.searchRegionControl, this);
      });
    }
    this.dataSource = new TableDataSource(this.dataSubject, this.paginator, this.sort);

    this.form.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe(form => {
        this.isSearchDisable = this._utility.searchDisable(form, ['searchNameControl'], true);
      });

    this.form.controls.searchRegionControl.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.regionChanges(value);
      });

    this.form.controls.searchNameControl.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.nameChanges(value);
      });
  }

  ngOnDestroy(): void {
      this.featureFlags.stop();
  }

  onSearchClick() {
    let params = "?userRole="+userRole_regionalAdmin+"&";
    let controls = this.form.controls;
    this._utility.addLoaderCount();
    if (controls.searchNameControl.value)
      params += `searchText=${controls.searchNameControl.value}&`;
    if (controls.searchRegionControl.value && controls.searchRegionControl.value.id)
      params += `regionId=${controls.searchRegionControl.value.id}&`;
    this._sharedService.getUsers(params.substring(0, params.length - 1)).subscribe(response => {
      this._utility.removeLoaderCount();
      //initialize index of grid pagination after every search
      this.paginator.pageIndex = 0;
      this.dataSource.curPage = 2;
      this.dataSubject.next(response.response.results);
      this.adminDetailPaginationInfo = response.response.paginationInfo; // update paginaton info
    }, error => this._utility.onErrorCallback(error));
  }

  /**
     * reset blank list/data in First/Last name autocomplete
     * @param value - selected region
     */
  regionChanges(value) {
    this._utility.setDataInComboField('name', [], this.form.controls.searchNameControl, this);
  }

  /* This function called When we type something on search "Enter First Name or Last Name" field
  Presented with top 10 records matching the entered criteria.
  If there are three later typed then hit request after half seconds of that to get suggestion
  Set all returned data into nameOptions array
  */
  nameChanges(searchInput: string): void {
    let distinctRecord = [];
    if (searchInput && searchInput.length > 2) {
      let params = "?userRole="+userRole_regionalAdmin+"&";
      let controls = this.form.controls;
      if (controls.searchNameControl.value) {
        params += "searchText=" + controls.searchNameControl.value + "&";
      }
      if (controls.searchRegionControl.value && controls.searchRegionControl.value.id) {
        params += "regionId=" + controls.searchRegionControl.value.id + "&";
      }
      this._sharedService.getUsers(params.substring(0, params.length - 1))
        .subscribe(
        response => {
          this._utility.onSuccessCallback(response, null, () => {
            let adminList = response.response.results;
            if (controls.searchNameControl.value && adminList.length > 0) {
              distinctRecord = this._utility.checkDuplicateRecord(adminList);
            }
            this._utility.setDataInComboField('name', distinctRecord, this.form.controls.searchNameControl, this);
          }, false);
        },
        error => {
          this._utility.onErrorCallback(error, null, false);
        }
        );
    }
  }

  // Set admin status icons based on its value
  getStatusCls(value) {
    try {
      if (value == 1) return 'activeStatusCls';
      if (value == 3) return 'retireStatusCls';
    }
    catch (Exception) { }
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-regional-admin/adm-manage-regional-admin.component.ts